<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import dayjs from '@/libs/util.date'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageHeader, PageMain },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzReplenishmentListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          const data = res.body.data
          this.tableData = (data || []).map((item) => {
            const { endDate: date } = item
            if (!date) return item
            const currDate = new Date(dayjs().format('YYYY-MM-DD')).getTime()
            const endDate = new Date(dayjs(date).format('YYYY-MM-DD')).getTime()
            const endDays = (currDate - endDate) / (1000 * 60 * 60 * 24)
            return { ...item, endDays }
          })
          this.page.pageTotal = res.body.count
          this.page.pageSize = res.body.pageSize
          this.page.curPage = res.body.curPage
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-awsBiz-replenishmentConfirm-detail',
        params: { ...params, pageType },
        query,
      })
    },
  },
}
</script>
